export default function RequiredStar() {
  return <span className="required-star">*</span>;
}
